"use client";

import { FlexRowAlignCenter } from "@/components/Flex";
import { useTextToSpeechContextSelector } from "@/contexts/TextToSpeechContext";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import { useCheckAuth } from "@/hooks/useCheckAuth";
import { Flashcard, FlashcardSide } from "@knowt/syncing/graphql/schema";
import { useCallback } from "react";

const WithClickFlashcardAudio = ({
    side,
    flashcard,
    children,
}: {
    children: React.ReactNode;
    side: FlashcardSide;
    flashcard: Flashcard;
}) => {
    const { checkAuth } = useCheckAuth();
    const handlePlayAudio = useTextToSpeechContextSelector(state => state.handlePlayAudio);

    const handleOnClick = useCallback(async () => {
        const isAuthenticated = await checkAuth({
            event: AuthEvent.PLAY_AUDIO,
        });

        if (!isAuthenticated) return;

        await handlePlayAudio(side, { flashcard });
    }, [checkAuth, handlePlayAudio, side, flashcard]);

    return (
        <FlexRowAlignCenter style={{ flex: 1 }} onClick={handleOnClick}>
            {children}
        </FlexRowAlignCenter>
    );
};

export default WithClickFlashcardAudio;
